import { LoadingSpinner } from '@/components/LoadingSpinner';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const EmployeeGroupsContainer = lazy(() =>
  import('@features/employee-groups/components/EmployeeGroupsContainer').then((module) => ({
    default: module.EmployeeGroupsContainer,
  }))
);

export const Route = createFileRoute('/_auth/groups')({ component: EmployeeGroupsComponent });

function EmployeeGroupsComponent() {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<LoadingSpinner message={t('common.splash.loading')} />}>
      <EmployeeGroupsContainer />
    </Suspense>
  );
}
